import React, { useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Collapse,
  Box
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CronoanaliseTabela = ({ vetor, selecionar, remover }) => {
  const [expandedRow, setExpandedRow] = useState(null);

  const formatarData = (data) => {
    if (!data) return '';
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR');
  };

  const formatarTempo = (tempo) => {
    try {
      if (!tempo && tempo !== 0) return '-';
      const tempoNum = parseFloat(tempo);
      if (isNaN(tempoNum)) return '-';
      return tempoNum.toFixed(2);
    } catch (error) {
      console.warn('Erro ao formatar tempo:', error);
      return '-';
    }
  };


  if (!vetor || vetor.length === 0) {
    return (
      <Paper sx={{ p: 2, mt: 2 }}>
        <Typography variant="body1" align="center">
          Nenhuma cronoanálise registrada
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="none" width={50} />
            <TableCell>Data</TableCell>
            <TableCell>Produto/Modelo</TableCell>
            <TableCell>Setor</TableCell>
            <TableCell>Operação</TableCell>
            <TableCell>Operador</TableCell>
            <TableCell>Máquina/Posto</TableCell>
            <TableCell>Tempo Total</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vetor.map((item) => (
            <React.Fragment key={item.id}>
              <TableRow>
                <TableCell padding="none">
                  <IconButton
                    size="small"
                    onClick={() => setExpandedRow(expandedRow === item.id ? null : item.id)}
                  >
                    {expandedRow === item.id ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </TableCell>
                <TableCell>{formatarData(item.data)}</TableCell>
                <TableCell>{item.modelo}</TableCell>
                <TableCell>{item.setor}</TableCell>
                <TableCell>{item.operacao}</TableCell>
                <TableCell>{item.operador}</TableCell>
                <TableCell>{item.maqPosto}</TableCell>
                <TableCell>{item.tempo ? `${parseFloat(item.tempo).toFixed(1)}s` : '0.0s'}</TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() => selecionar(item)}
                    color="primary"
                    title="Editar"
                  >
                    <EditIcon />
                  </IconButton>
                  {remover && (
                    <IconButton
                      size="small"
                      onClick={() => remover(item.id, item.modelo)}
                      color="error"
                      title="Remover"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                  <Collapse in={expandedRow === item.id} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                      <Typography variant="h6" gutterBottom component="div">
                        Detalhes da Cronoanálise
                      </Typography>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Informação</TableCell>
                            <TableCell>Valor</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>Cronometrista</TableCell>
                            <TableCell>{item.cronometrista || '-'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Tempo Total (s)</TableCell>
                            <TableCell>{item.tempo ? `${formatarTempo(item.tempo)}` : '-'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Tempo Calculado</TableCell>
                            <TableCell>{item.tempoCalculado ? parseFloat(item.tempoCalculado).toFixed(4): '-'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Frequência Lógica</TableCell>
                            <TableCell>{item.freqLogicaNumerador && item.freqLogicaDenominador ? 
                              `${item.freqLogicaNumerador}/${item.freqLogicaDenominador}` : '-' }</TableCell>
                          </TableRow>
                          {/*
                          <TableRow>
                            <TableCell>Frequência Lógica Total</TableCell>
                            <TableCell>{item.freqLogicaTotal ? `${item.freqLogicaTotal}` : '-'}</TableCell>
                          </TableRow>*/}

                          {/*
                          <TableRow>
                            <TableCell>Número de Observações</TableCell>
                            <TableCell>{item.numeroObs ? `${item.numeroObs}` : '-'}</TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>Eficiência (%)</TableCell>
                            <TableCell>{item.eficiencia ? `${formatarTempo(item.eficiencia)}%` : '-'}</TableCell>
                          </TableRow>
                          {/*
                          <TableRow>
                            <TableCell>Eficiência Total (%)</TableCell>
                            <TableCell>{item.eficienciaTotal ? `${formatarTempo(item.eficienciaTotal)}%` : '-'}</TableCell>
                          </TableRow>*/}

                          <TableRow>
                            <TableCell>Tolerância (%)</TableCell>
                            <TableCell>{item.tolerancia ? `${formatarTempo(item.tolerancia)}%` : '-'}</TableCell>
                          </TableRow>

                          {/*<TableRow>
                            <TableCell>Soma de Tempos</TableCell>
                            <TableCell>{item.somaTempos ? `${formatarTempo(item.somaTempos)}` : '-'}</TableCell>
                          </TableRow>*/}

                          <TableRow>
                            <TableCell>Produtividade/Hora</TableCell>
                            <TableCell>
                              {item.produtividadeHora?.toLocaleString('pt-BR', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3 
                              })}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Produtividade/Hora (Inf)</TableCell>
                            <TableCell>{(item.produtividadeHoraInf)}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Produtividade/Dia</TableCell>
                            <TableCell>
                              {item.produtividadeDia?.toLocaleString('pt-BR', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3
                              })}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Produtividade/Dia (Inf)</TableCell>
                            <TableCell>{(item.produtividadeDiaInf)}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>

                      <Typography variant="h6" gutterBottom component="div" sx={{ mt: 2 }}>
                        Tempos Detalhados
                      </Typography>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Sequência</TableCell>
                            <TableCell>Tempo</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {item.temposDetalhados?.map((tempo, index) => (
                            <TableRow key={tempo.id || index}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{formatarTempo(tempo.time)}</TableCell>
                              <TableCell>{tempo.selected ? 'Ativo' : 'Inativo'}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CronoanaliseTabela;